import { formatNumberWithCustomSeparator } from './formatNumberWithCustomSeparator';
import { getIntlNumberSeparators } from './get-intl-number-separators';

/**
  Данная утилита нужна во время редактирования полей, например Number Field или Inline Input
  Благодаря этой утилите, мы запрещаем ввод заведомо невалидных символов,
  А так же подменяем разделитель сотых частей на тот, который используется в локали юзера
  Например: пользователь вводит ".", но в его локали за разделение сотых отвечает ",", то вместо "." пользователь увидит ","
*/
export function formatNumberWithSeparatorOnEdit(
  value: number | string,
  decimalSeparator?: string
): string {
  const { decimalSeparator: userLocaleDecimalSeparator } =
    getIntlNumberSeparators();
  const finalSeparator = decimalSeparator || userLocaleDecimalSeparator;

  const cleanedValue = cleanValue(value);

  return withDecimalSeparatorOnEnd(cleanedValue, finalSeparator);
}

const withDecimalSeparatorOnEnd = (value: string, separator: string) => {
  // тк formatNumberBySeparator удаляет разделитель на конце, мы ее добавляем обратно, если она там была
  const hasSeparatorOnEnd = value.at(-1) === '.';

  // Форматируем разделитель
  const finalValue = formatNumberWithCustomSeparator(value, '', separator);

  return String(finalValue) + (hasSeparatorOnEnd ? separator : '');
};

const cleanValue = (value: number | string) => {
  // Удаляет все символы, кроме цифр, запятых, точек и первого дефиса, а после заменяем все запятые на точки
  const cleanedValue = String(value)
    .replace(/(?!^)-|[^\d.,-]+/g, '')
    .replaceAll(/[.,]/g, '.');
  // Оставляем только одну точку и сотую часть после него
  return cleanedValue.replace(/^(\d*\.\d*)\..*/, '$1');
};
